import { setBasePath } from '@shoelace-style/shoelace/dist/utilities/base-path.js';
setBasePath('/Users/ahmedgabal/Lab/PRODUCTS/VOXY-AI/web/node_modules/shoelace-style/shoelace/dist')

import './fonts/fonts.css'
import './lib/components/vxc_session_view'
import './lib/components/vxc_session_dialog_view'
import './lib/components/vxc_conversation'
import './lib/components/vxc_value_card'
import './lib/components/vxc_navbar'
import './lib/components/vxc_input'
import './lib/components/vxc_select'
import './lib/components/vxc_input_tags'
import './lib/components/vxc_websrc_editor'
import './lib/components/vxc_chatbot_editor'
import './lib/components/vxc_chatbot_demo'
import './lib/components/vxc_chatbot_kpi'
import './lib/components/vxc_knowledge_base'
import './lib/components/vxc_sidebar'
import './lib/components/vxc_login'
// import './lib/components/chat/vx_chatbot'
// import './lib/components/chat/vx_doclist'
// import './lib/components/chat/vx_register'
// import './lib/components/chat/vx_app'
import './lib/apps/vx_iamie_app'
import './lib/apps/vxa_iamie_dashboard'

import './lib/components/vxc_chatbot'
import './lib/components/wrappers/iamie'

import {start} from './lib/components/wrappers/voxyapp'
start('iamie', 'https://api.iamie.fr')
// window.voxyapp.login('test1@me.com', 'abcdefghijklm')
console.log('ready !', window.voxyapp.token)
